import React, { useMemo, useRef } from 'react';
import { withStyles, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { hasPermission, hasAtLeastOnePermission } from '../../sc-utilities';
import WorkProductAuditRecordList from "./WorkProductAuditRecordList";

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '-1%',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            width: '100%'
        }
    },
    "@global": {
        "[class*='statusActive']": {
            color: theme.palette.success.dark
        },
        "[class*='statusInactive']": {
            color: theme.palette.error.dark
        },
        "[class*='button']": {
            textTransform: 'none',
            textDecoration: 'none'
        }
    },
    button: {
        textTransform: 'none',
        textDecoration: 'none'
    },
    statusActive: {
        color: theme.palette.success.dark
    },
    statusInactive: {
        color: theme.palette.error.dark
    }
});

const WorkProductAuditRecord = props => {
    const tableRef = useRef();
    const { classes, translations, permissions, editable, columns, productID } = props;
    const visible = columns && columns['AuditRecord'];

    // const getYesNoValue = (value) => {
    //     if (value === null) {
    //         return translations["short_not_assigned"] || "n/a";
    //     }

    //     if (value?.toString() === '-1') {
    //         return translations["short_not_assigned"] || "n/a";
    //     }
        
    //     return value ? translations["yes"] || 'Yes' : translations["no"] || 'No';
    // }
    // const defaultYesNoFilter = ['0', '1', 'n/a'];

    const getValues = (value) => {
        switch(value){
            case(0):
                return translations["no"] || 'No'
            case(1):
                return translations["yes"] || 'Yes';
            case(-1):
            default:
                return translations["short_not_assigned"] || "n/a";
        }
    }

    const allFilters = ['0','1','null'];
    const lookup = { 
        '1': translations["yes"] || 'Yes', 
        '0': translations["no"] || 'No', 
        'null': translations['short_not_assigned'] || 'n/a' 
    };

    const tableColumns = useMemo(() => {
        return [
            {
                title: translations['mdm'] || 'MDM', field: 'MDM',
                hidden: visible ? visible['MDM'] : false,
                filtering: true,
                lookup: lookup,
                defaultFilter: allFilters,
                render: rowData => <Typography variant={'caption'}>{getValues(rowData.MDM)}</Typography>
            },
            {
                title: translations['dep'] || 'DEP', field: 'DEP',
                hidden: visible ? visible['DEP'] : false,
                filtering: true,
                lookup: lookup,
                defaultFilter: allFilters,
                render: rowData => <Typography variant={'caption'}>{getValues(rowData.DEP)}</Typography>
            },
            {
                title: translations['fmm'] || 'Find My Mac', field: 'FMM',
                hidden: visible ? visible['FMM'] : false,
                filtering: true,
                lookup: lookup,
                defaultFilter: allFilters,
                render: rowData => <Typography variant={'caption'}>{getValues(rowData.FMM)}</Typography>
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible]);

    if (!hasAtLeastOnePermission(permissions, ["product_audit_record_delete"])) {
        tableColumns.shift();
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'product_audit_record_list') &&
                <WorkProductAuditRecordList editable={editable} productID={productID} tableColumns={tableColumns} tableRef={tableRef} />}
        </div >
    );

}
const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
    };
};


export default connect(
    mapStateToProps,
    null,
)(withStyles(styles, { withTheme: true })(WorkProductAuditRecord))
